<div class="automation-rules">

  <sc-master-detail [selection]="[selectedProfile]" [data]="profiles" (selectionChanged)="onSelectionChanged($event);"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);" [newStyle]="true">
    <sc-scroll-pane>
      <form [formGroup]="detailsForm" *ngIf="selectedProfile != null">
        <div class="automation-rule-details no-field-space">
          <mat-tab-group>
            <mat-tab
              [label]="'base data' | translate: ['tmc-yard.ui.admin.transport-creation-profiles.base-data', translationService.language, translationService.revision]">
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field formControlName="active" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.active">
              </sc-checkbox-field>
              <sc-flex>
                <sc-checkbox-field formControlName="hasQrCode" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.has-qr-code">
                </sc-checkbox-field>

                <sc-content-spacer grow></sc-content-spacer>
                <sc-button dictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.create-pdf" [disabled]="!selectedProfile.hasQrCode" (click)="createPDF()"></sc-button>
              </sc-flex>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-string-field formControlName="name" labelDictionaryKey="tmc-yard.common.name">
              </sc-string-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field formControlName="hasActionTablet" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.has-action-tablet">
              </sc-checkbox-field>

              <ng-container *ngIf="displayNameVisible">
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-string-field formControlName="displayName" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.display-name">
                </sc-string-field>
              </ng-container>
              <sc-content-spacer vertical></sc-content-spacer>
            </mat-tab>
            <mat-tab
              [label]="'properties' | translate: ['tmc-yard.ui.admin.transport-creation-profiles.properties', translationService.language, translationService.revision]">
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field formControlName="allowParallelAccess" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.allow-parallel-access">
              </sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field formControlName="withRouting" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.with-routing">
              </sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-read-only-field *ngIf="!numberPlateEnabled"
                labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.hash-code"
                [value]="selectedProfile?.hashCode">
              </sc-read-only-field>
              <sc-content-spacer *ngIf="!numberPlateEnabled" vertical></sc-content-spacer>
              <sc-string-field formControlName="carrier" labelDictionaryKey="tmc-yard.entity.transport.carrier">
              </sc-string-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-string-field formControlName="driver" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.driver">
              </sc-string-field>
              <sc-content-spacer *ngIf="!numberPlateEnabled" vertical></sc-content-spacer>
              <sc-string-field *ngIf="!numberPlateEnabled" formControlName="numberPlate" labelDictionaryKey="tmc-yard.entity.transport.numberplate">
              </sc-string-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-string-field formControlName="orderReference" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.order-reference">
              </sc-string-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-padding>
                <app-transport-options-panel [model]="transportOptionsPanelModel"></app-transport-options-panel>
              </sc-padding>

            </mat-tab>
            <mat-tab
              [label]="'number-plates' | translate: ['tmc-yard.ui.admin.transport-creation-profiles.number-plates', translationService.language, translationService.revision]">
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field formControlName="hasNumberPlateList" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.has-number-plate-list">
              </sc-checkbox-field>
              <app-number-plate *ngIf="numberPlateEnabled" [selectedProfile]="selectedProfile"
                (deleteClicked)="deleteNumberPlate($event)" (changeActiveClicked)="changeNumberPlateActive($event)"
                (addNewNumberPlateClicked)="addNewNumberPlate($event)"></app-number-plate>
            </mat-tab>
          </mat-tab-group>
        </div>

      </form>
    </sc-scroll-pane>

    <ng-template masterDetailToolbar>

      <sc-cancel-button class="config-changed-button" (click)="cancel()" [disabled]="!cancelEnabled"></sc-cancel-button>
      <div class="spacer"></div>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary class="config-changed-button" (click)="save()" [disabled]="!saveEnabled"></sc-save-button>

    </ng-template>
  </sc-master-detail>

</div>
